// extracted by mini-css-extract-plugin
export var dropdownIcon = "_l0-6";
export var imgContainer = "_l0-3";
export var menuIcon = "_l0-5";
export var pillWrapper = "_l0-2";
export var pillsContainer = "_l0-1";
export var subscriptionCard = "_l0-0";
export var subscriptionLogo = "_l0-4";